import { normalizeHtmlText } from '@shared/helpers/text/normalizeHtmlText';

export const getGeneralComments = (room, cancelationFee) => {
  const normalize = value => {
    if (!value) return [];
    return Array.isArray(value) ? value : [value];
  };

  return Array.from(
    new Set(
      [
        ...normalize(room?.general_comments),
        ...normalize(cancelationFee?.general_comments),
      ].filter(Boolean)
    )
  );
};

export const dedupeGroupedComments = groups => {
  const seen = new Set();

  return groups.map(group =>
    group
      .map(comment => normalizeHtmlText(comment))
      .filter(comment => {
        const key = comment.toLowerCase();

        if (!key || seen.has(key)) {
          return false;
        }

        seen.add(key);

        return true;
      })
  );
};
